import * as React from 'react';
import PropTypes from 'prop-types';
import * as ReactModal from 'react-modal';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Button from '../Button';

import './style.scss';

const Modal = props => {
  return (
    <ReactModal
      className={`modal ${props.type === 'image' ? 'is-image-modal' : ''}`}
      isOpen={props.isOpen}
      contentLabel="Modal"
      onRequestClose={props.close}
      shouldCloseOnOverlayClick={true}
      closeTimeoutMS={300}
      onAfterOpen={(i) => {
        disableBodyScroll(i);
      }}
      onAfterClose={() => {
        clearAllBodyScrollLocks();
      }}
    >
      <Button
        color="secondary"
        icon="cross"
        label={`Close${props.type === 'image' ? ' the image' : ''}`}
        onClick={props.close}
      />
      <div className="scrollable-content">{props.children}</div>
    </ReactModal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  type: PropTypes.string,
};

export default Modal;
